import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { GetAll } from "../../../../../../features/admin/instrument_management/Slice";
import { formatDate } from "../../../../../../utils/common";

const Instrument_Report_Table = ({ setEdit, searchName }) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const instrument_management = useSelector(
    (state) => state.instrument_management,
  );

  const permissions = useSelector((state) => state.auth.permissions);
  const auth = useSelector((state) => state.auth.role_id);

  const havePermission = permissions?.includes(
    FixIDS.Instrument_management.Edit,
  );

  const [currentPage, setCurrentPage] = useState(1);

  // Fetch customers from API
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        createdAt: searchName.createdAt || "",
        unique_id: searchName.unique_id || "",
        instrument_name: searchName.instrument_name || "",
        calibration_status_id: searchName.calibration_status_id || "",
        calibrated_id: searchName.calibrated_id || "",
        //name: searchName,
        start_date: searchName.start_date || "",
        end_date: searchName.end_date || "",
        year: searchName.year || "",
        page: page,
        per_page: instrument_management.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [searchName, currentPage, dispatch]);

  const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "green";
      case "Maintenance":
        return "blue";
      case "Out of Service":
        return "red";
      default:
        return "";
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                {/* <th>
                  <input type="checkbox" />
                </th> */}
                <th>Sr.No</th>
                <th>Date</th>
                <th>Instrument ID</th>
                <th>Instrument Name</th>
                <th>Model</th>
                <th>Serial No.</th>
                <th>Calibrated By</th>
                <th>Last Calibrated</th>
                <th>Next Calibration Due</th>
                <th>Calibration Perform</th>
                <th>Certificate No</th>
                <th>Calibration Status</th>
                {/* <th>View Certificate</th> */}
              </tr>
            </thead>

            <tbody>
              {Array.isArray(instrument_management?.data) &&
              instrument_management?.data?.length > 0 ? (
                instrument_management?.data?.map((row, index) => (
                  <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                    <td>
                      {(currentPage - 1) *
                        (instrument_management?.per_page ||
                          instrument_management?.data?.length ||
                          0) +
                        index +
                        1}
                    </td>
                    <td>{formatDate(row?.createdAt)}</td>
                    <td>{row?.unique_id}</td>
                    <td>{row?.instrument_name}</td>
                    <td>{row?.model_no}</td>
                    <td>{row?.serial_no}</td>
                    {/* <td>{row?.User?.name}</td> */}
                    <td>{row?.calibrated_by}</td>
                    <td>
                      {row?.createdAt
                        ? new Date(row.last_calibrated).toLocaleDateString(
                            "en-IN",
                          )
                        : "-"}
                    </td>
                    <td>
                      {row?.createdAt
                        ? new Date(row.next_calibration_due).toLocaleDateString(
                            "en-IN",
                          )
                        : "-"}
                    </td>
                    <td>
                      {row?.createdAt
                        ? new Date(row.calibration_perform).toLocaleDateString(
                            "en-IN",
                          )
                        : "-"}
                    </td>
                    <td>{row?.calibration_certificate_no}</td>

                    {/* Status Color Based */}
                    <td
                      className={`status ${getStatusClass(
                        row?.Calibration_Status?.name,
                      )}`}
                    >
                      <p>{row?.Calibration_Status?.name}</p>
                    </td>

                    {/* <td>
                      <p
                        onClick={() => {
                          setCertificateImg(
                            row.image
                              ? `${process.env.REACT_APP_IMG_URL}${row?.image}`
                              : "",
                          );
                          setShowModal(true);
                        }}
                        className="common_link_text2"
                      >
                        View Certificate
                      </p>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing{" "}
            {(instrument_management.current_page - 1) *
              instrument_management.per_page +
              1}{" "}
            To{" "}
            {Math.min(
              instrument_management.current_page *
                instrument_management.per_page,
              instrument_management.total,
            )}{" "}
            Of {instrument_management.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={instrument_management.current_page}
            totalPages={instrument_management.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Instrument_Report_Table;
